// This file is generated by Sapper — do not edit it!
export { default as Root } from '../../../routes/_layout.svelte';
export { preload as root_preload } from '../../../routes/_layout.svelte';
export { default as ErrorComponent } from '../../../routes/_error.svelte';

export const ignore = [/^\/album\/album-store\/?$/, /^\/blog.json$/, /^\/blog\/([^\/]+?).json$/, /^\/api\/comments.json$/, /^\/api\/reception.json$/, /^\/api\/reception\/form.json$/, /^\/api\/reception\/([^\/]+?).json$/, /^\/api\/sad.json$/, /^\/api\/album\/gal.json$/, /^\/api\/album\/([^\/]+?).json$/, /^\/api\/menu\/([^\/]+?).json$/, /^\/api\/str\/start.txt$/, /^\/api\/str\/([^\/]+?).txt$/, /^\/api\/wgu\/([^\/]+?).json$/];

export const components = [
	{
		js: () => import("../../../routes/index.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/reception/index.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/reception/form.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/reception/[id].svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/comments/index.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/about.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/album/_layout.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/album/index.svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/album/[id].svelte"),
		css: ["client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/blog/index.svelte"),
		css: ["index.9dd99125.css","client.abf99526.css"]
	},
	{
		js: () => import("../../../routes/blog/[slug].svelte"),
		css: ["[slug].9a2942ca.css","client.abf99526.css"]
	}
];

export const routes = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// reception/index.svelte
		pattern: /^\/reception\/?$/,
		parts: [
			{ i: 1 }
		]
	},

	{
		// reception/form.svelte
		pattern: /^\/reception\/form\/?$/,
		parts: [
			null,
			{ i: 2 }
		]
	},

	{
		// reception/[id].svelte
		pattern: /^\/reception\/([^\/]+?)\/?$/,
		parts: [
			null,
			{ i: 3, params: match => ({ id: d(match[1]) }) }
		]
	},

	{
		// comments/index.svelte
		pattern: /^\/comments\/?$/,
		parts: [
			{ i: 4 }
		]
	},

	{
		// about.svelte
		pattern: /^\/about\/?$/,
		parts: [
			{ i: 5 }
		]
	},

	{
		// album/index.svelte
		pattern: /^\/album\/?$/,
		parts: [
			{ i: 6 },
			{ i: 7 }
		]
	},

	{
		// album/[id].svelte
		pattern: /^\/album\/([^\/]+?)\/?$/,
		parts: [
			{ i: 6 },
			{ i: 8, params: match => ({ id: d(match[1]) }) }
		]
	},

	{
		// blog/index.svelte
		pattern: /^\/blog\/?$/,
		parts: [
			{ i: 9 }
		]
	},

	{
		// blog/[slug].svelte
		pattern: /^\/blog\/([^\/]+?)\/?$/,
		parts: [
			null,
			{ i: 10, params: match => ({ slug: d(match[1]) }) }
		]
	}
])(decodeURIComponent);